export default "__VITE_ASSET__D0E5Q2AQ__"